import React from"react";
import { useNavigate } from"react-router-dom";
import { FaUserGraduate, FaUniversity } from"react-icons/fa";

const roles = [
 {
 label:"Learner",
 value:"student",
 icon: <FaUserGraduate className="text-3xl" />,
 path:"/login",
 description: "Access learning resources, practice, and more",
 },
 {
 label:"College / Institution",
 value:"college",
 icon: <FaUniversity className="text-3xl" />,
 path:"/college-intro",
 description: "Register your institution and get your dedicated portal",
 },
 {
 label:"TSG Nexus",
 value:"nextgen_builder",
 icon: <FaUserGraduate className="text-3xl text-secondary" />,
 path:"/nextgen-builder/register",
 description: "Build production-grade products, collaborate with teams, complete real-world projects, and become industry-ready.",
 },
];

const UserTypeSelector = () => {
 const navigate = useNavigate();

 const handleSelect = (path) => {
 navigate(path);
 };

 return (
 <div className="min-h-screen bg-bgMain text-body flex items-center justify-center px-4 py-8 sm:py-12">
 <div
 className="w-full max-w-xl p-6 sm:p-10 bg-bgSection border border-primary/30 rounded-2xl shadow-2xl text-center"
 style={{ boxShadow:"0 0 30px rgba(37, 99, 235, 0.2)" }}
 >
 <h2 className="text-primary text-2xl sm:text-3xl font-bold mb-2">
 Perfect! Now please let us know
 </h2>
 <p className="text-muted text-lg mb-8">
 What describes you the most?
 </p>

 <div className="space-y-6">
 {roles.map((role, index) => (
 <div
 key={index}
 onClick={() => handleSelect(role.path)}
 className={`flex items-center gap-4 px-6 py-4 border rounded-xl w-full transition-all duration-300 cursor-pointer bg-bgMain text-body border-primary/30 hover:bg-gradient-to-r hover:from-primary hover:to-secondary hover:border-transparent hover:shadow-lg group`}
 >
 <span className="text-primary group-hover:text-white transition-colors">{role.icon}</span>
 <div className="text-left">
 <p className="text-xl font-semibold">{role.label}</p>
 {role.description && (
 <p className="text-xs text-muted group-hover:text-white/80 mt-0.5 transition-colors">{role.description}</p>
 )}
 </div>
 </div>
 ))}
 </div>
 </div>
 </div>
 );
};

export default UserTypeSelector;



